var map = {
	"./dv_msg_ar.json": 2069,
	"./dv_msg_de.json": 2070,
	"./dv_msg_en.json": 2071,
	"./dv_msg_es.json": 2072,
	"./dv_msg_fr.json": 2073,
	"./dv_msg_it.json": 2074,
	"./dv_msg_ja.json": 2075,
	"./dv_msg_nl.json": 2076,
	"./dv_msg_pt.json": 2077,
	"./dv_msg_zh.json": 2078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2068;